module.exports = __webpack_public_path__ + "static/media/eye.3fa23634.svg";